import { gql, useQuery } from "@apollo/client";
import { useApplicationContext } from "components/Application";
import { CenterSpinner } from "components/CenterSpinner";
import { capitalize } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import tw from "twin.macro";

const collectionBrandQuery = gql`
  query ($brandId: ID!) {
    collectionBrand(id: $brandId) {
      id
      code
      nameEn
      nameIt
      descriptionEn
      descriptionIt
      coverVertical
      position
    }
  }
`;

export const PressKit: React.FC<{}> = () => {
  const {
    siteEnvironment: { appEndpointStore },
  } = useApplicationContext();
  const { brandId } = useParams();

  const { i18n } = useTranslation();
  const languageSuffix = capitalize(i18n.language);

  const variables = {
    brandId,
  };

  const { loading, data } = useQuery(collectionBrandQuery, { variables, fetchPolicy: "cache-and-network" });
  if (loading) return <CenterSpinner size="large" />;

  const { collectionBrand: brand } = data;
  const even = brand.position % 2;

  return (
    <div
      css={[
        tw`flex h-full bg-cover flex-row bg-no-repeat bg-center bg-top items-end justify-start`,
        !even && tw`flex-row-reverse`,
      ]}
    >
      <div
        tw="flex h-full w-1/2 bg-cover bg-no-repeat bg-center bg-top items-end p-8 justify-start"
        style={{
          backgroundImage: `url(${appEndpointStore}${brand.coverVertical})`,
          height: "calc(100vh - 4rem)",
        }}
      />
      <div
        tw="flex h-auto flex-col justify-between w-1/2 px-8 pb-8"
        style={{
          height: "calc(100vh - 4rem)",
        }}
      >
        {brand.descriptionEn && (
          <div>
            <p tw="font-bold text-2xl">{`${brand[`name${languageSuffix}`]}`.toUpperCase()}</p>
            <p>{brand[`description${languageSuffix}`]}</p>
          </div>
        )}
        <div css={[tw`flex flex-row`, !even && tw`flex-row-reverse`]}>
          <div tw="flex flex-col space-y-4" style={{ width: "fit-content" }}>
            <a
              tw="block bg-gray-900 uppercase text-center border-default py-2 px-8 text-white outline-none hover:(bg-white text-gray-900)"
              target="_blank"
              rel="noreferrer"
              href={`/${brand.code}-lookbook.pdf`}
            >
              LOOKBOOK {brand[`name${languageSuffix}`]}
            </a>
            {/* <a
              tw="block bg-gray-900 uppercase text-center border-default py-2 px-8 text-white outline-none hover:(bg-white text-gray-900)"
              target="_blank"
              rel="noreferrer"
              href={`/${brand.code}-linesheet.pdf`}
            >
              LINESHEET {brand[`name${languageSuffix}`]}
            </a>
            <a
              tw="block bg-gray-900 uppercase text-center border-default py-2 px-8 text-white outline-none hover:(bg-white text-gray-900)"
              target="_blank"
              rel="noreferrer"
              href={`/${brand.code}-poster.pdf`}
            >
              POSTER {brand[`name${languageSuffix}`]}
            </a> */}
          </div>
        </div>
      </div>
    </div>
  );
};
